// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuestionsWidget_wrapper__OHf3C","wrapper_inner":"QuestionsWidget_wrapper_inner__DLf7I"};